import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
  console.log('✅ Login component with username/email support');
  
  const [formData, setFormData] = useState({
    login: '', // Can be either username or email
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authAPI.login({ 
        login: formData.login,
        password: formData.password 
      });
      
      const { access_token, user } = response.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('user', JSON.stringify(user));
      
      toast.success('Welcome back!');
      // Force page reload to trigger App.js auth check
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
    } catch (error) {
      const errorMsg = error.response?.data?.error || error.response?.data?.message || 'Login failed';
      toast.error(errorMsg);
      console.error('Login error:', error);
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <ToastContainer position="top-right" autoClose={3000} theme="dark" />
      
      <div style={{
        backgroundColor: '#1a1a1a',
        border: '1px solid #333',
        borderRadius: '12px',
        padding: '40px',
        width: '100%',
        maxWidth: '450px',
        boxShadow: '0 10px 40px rgba(255, 182, 193, 0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <div style={{ marginBottom: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src="/bestie_logo.png" alt="Bestie" style={{ width: '80px', height: '80px', objectFit: 'contain', display: 'block' }} />
          </div>
          <h1 style={{ 
            fontSize: '2rem', 
            fontWeight: '600', 
            marginBottom: '10px',
            color: '#ffffff',
            margin: '0 0 10px 0'
          }}>
            Welcome Back
          </h1>
          <p style={{ color: '#999', fontSize: '0.95rem', margin: 0 }}>
            Sign in to BestieConnect
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ 
              display: 'block', 
              marginBottom: '8px', 
              color: '#ffffff',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>
              👤 Username or Email
            </label>
            <input
              type="text"
              name="login"
              value={formData.login}
              onChange={handleChange}
              required
              placeholder="username or email@example.com"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <label style={{ 
                color: '#ffffff',
                fontSize: '0.9rem',
                fontWeight: '500'
              }}>
                🔒 Password
              </label>
              <Link 
                to="/forgot-password" 
                style={{ 
                  color: '#FFB6C1', 
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  fontWeight: '500'
                }}
              >
                Forgot Password?
              </Link>
            </div>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              style={{
                width: '100%',
                padding: '12px 15px',
                backgroundColor: '#0a0a0a',
                border: '1px solid #333',
                borderRadius: '8px',
                color: '#ffffff',
                fontSize: '1rem',
                outline: 'none',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: '#FFB6C1',
              color: '#000000',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              transition: 'all 0.2s'
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={{ 
          marginTop: '30px', 
          textAlign: 'center',
          paddingTop: '20px',
          borderTop: '1px solid #333'
        }}>
          <p style={{ color: '#999', fontSize: '0.9rem', marginBottom: '10px' }}>
            Don't have an account?{' '}
            <Link 
              to="/register" 
              style={{ 
                color: '#FFB6C1', 
                textDecoration: 'none',
                fontWeight: '600'
              }}
            >
              Create one
            </Link>
          </p>
          <p style={{ color: '#999', fontSize: '0.9rem', margin: 0 }}>
            <Link 
              to="/" 
              style={{ 
                color: '#666', 
                textDecoration: 'none',
                fontWeight: '500'
              }}
            >
              ← Back to Home
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
